module.exports = __webpack_public_path__ + "img/tailwind_logo.1117bd7f.png";